import { cn } from "@/lib/utils";

interface ProgressProps {
  value: number;
  max?: number;
  className?: string;
  trackClassName?: string;
}

export function Progress({
  value,
  max = 100,
  className,
  trackClassName,
}: ProgressProps) {
  const pct = Math.min(100, Math.max(0, (value / Math.max(max, 1)) * 100));

  return (
    <div
      role="progressbar"
      aria-valuenow={value}
      aria-valuemax={max}
      aria-valuemin={0}
      className={cn(
        "h-1.5 w-full overflow-hidden rounded-full bg-hair",
        className,
      )}
    >
      <div
        className={cn(
          "h-full rounded-full bg-foreground transition-all",
          trackClassName,
        )}
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
